// Copyright Materialize, Inc. and contributors. All rights reserved.
//
// Use of this software is governed by the Business Source License
// included in the LICENSE file.
//
// As of the Change Date specified in that file, in accordance with
// the Business Source License, use of this software will be governed
// by the Apache License, Version 2.0.

export const INVOICE_FETCH_ERROR_MESSAGE =
  "An error occurred loading invoices.";

export const FORBIDDEN_PAYMENT_ERROR_MESSAGE =
  "Only organization admins can manage payment methods. Contact an admin to make changes.";

export const ACCOUNT_SPEND_FETCH_ERROR_MESSAGE =
  "An error occurred loading your usage";
